import { useSelector } from 'react-redux';
import { Table } from 'antd';
import { formatPrice } from '../../../../util/formatPrice';

export const SettingsShowExchangeRateModal = () => {
  const { configs } = useSelector((state) => state.configs);
  const { subsidiaries } = useSelector((state) => state.subsidiary);

  const exchangeRates = configs?.exchangeRate || {};

  const dataSource = Object.entries(exchangeRates).map(([branchId, rate]) => {
    const branch = subsidiaries.find((s) => s.id === branchId);
    return {
      key: branchId,
      branch: branch ? branch.name : `Sucursal ${branchId}`,
      rate,
    };
  });

  const columns = [
    {
      title: 'Sucursal',
      dataIndex: 'branch',
      key: 'branch',
    },
    {
      title: 'Tipo de cambio',
      dataIndex: 'rate',
      key: 'rate',
      render: (value) => formatPrice(value),
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      bordered
      size="middle"
    />
  );
};
